import { ChangeDetectionStrategy, Component, computed, inject, Input } from '@angular/core';
import { CoreModalService, ModalWindowController } from '@reconcept-platform/shared/ui/core/modal';
import { ModalWindowComponent } from '../modal-window/modal-window.component';

@Component({
  selector: 'rcp-modal-container',
  template: `
    @for (modalInstance of activeModals(); track modalInstance) {
      <rcp-modal-window [modalInstance]="modalInstance"></rcp-modal-window>
    }
  `,
  styleUrls: ['./modal-container.component.scss'],
  imports: [ModalWindowComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ModalContainerComponent {
  modalService = inject(CoreModalService);
  private parentWindow = inject(ModalWindowController, { optional: true });

  @Input() outlet = 'root';

  // every open modal of the same kind has a container with this outlet, and the modals inside
  // resolve their services from it, so a modal only shows in the container of the modal that opened it
  activeModals = computed(() =>
    this.modalService
      .modals()
      .filter(
        (modal) => modal.outlet === this.outlet && (!this.parentWindow || modal.parentController === this.parentWindow),
      ),
  );
}
